import { render, staticRenderFns } from "./MyCheckInfo.vue?vue&type=template&id=68a8855e&scoped=true&"
import script from "./MyCheckInfo.vue?vue&type=script&lang=ts&"
export * from "./MyCheckInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a8855e",
  null
  
)

export default component.exports